import React from "react";

const VideoBackground = () => {
  return (
    <div className={'video-background'}>
      <video
        autoPlay
        loop
        muted
        playsInline
        poster="/video/poster.webp"
      >
	      <source src="/video/Bg01.webm" type="video/webm" />
	      <source src="/video/Bg01.mp4" type="video/mp4" />
	      Your browser does not support the video tag.
      </video>
    </div>
  );
};

export default VideoBackground;